import en from './locales/en.json';
import no from './locales/no.json';

export const useStaticTranslations = (lang = 'en') => {
  const translations = lang === 'no' ? no : en;

  const t = (key, vars = {}) => {
    let text = translations[key] || key;
    Object.keys(vars).forEach(k => {
      text = text.replace(`{{${k}}}`, vars[k]);
    });
    return text;
  };

  return { t };
};
